<app-collapsible [arrowElementRef]="loadArrow" [opened]="true">
    <div collapsibleHeader [ngClass]="isLoadSelected ? 'selected' : null" (click)="loadArrow.triggerToggle($event)">
        <div class="checkbox">
            <label *ngIf="carrierHasBluechat">
                <input type="checkbox"
                       (click)="selectLoad()"
                       [ngModel]="isLoadSelected"
                       [disabled]="!userCanCreateNote">
                <i class="fa checkbox-icon hasBorder"></i>
            </label>
        </div>
        <span class="load-info load"><strong class="info-label fixWidthLabelLoad"><span [i18n]="'bluechat.search.load.load-number'"></span>&nbsp;#{{load.loadNumber}}</strong></span>
        <span class="load-info vehicle"><i class="fa fa-truck"></i>&nbsp;<strong><span [i18n]="'bluechat.search.load.vehicle'"></span>: {{load.vehicle || '-'}}</strong></span>
        <span class="load-info status"><app-bluechat-load-status [status]="load.status"></app-bluechat-load-status></span>
        <span class="load-info deliveries"><strong><span [i18n]="'bluechat.search.load.deliveries'"></span>:&nbsp;{{load.deliveries.length}}/{{load.deliveriesCount}}</strong></span>
        <button class="btn btn-i btn-light" (click)="infoClick($event)">
            <i class="fa fa-info-circle"></i>&nbsp;<span [i18n]="'bluechat.search.load.info'"></span>
        </button>
        <app-collapsible-arrow #loadArrow></app-collapsible-arrow>
    </div>

    <div collapsibleBody>
        <app-bluechat-delivery *ngFor="let delivery of load.deliveries"
                               [delivery]="delivery"
                               [userCanCreateNote]="userCanCreateNote && loadStatusAllowNoteCreation"
                               [loadStatusAllowNoteCreation]="loadStatusAllowNoteCreation"
                               [loadStatusI18nKey]="'bluechat.load-status.'+load.status.toLowerCase()"
                               [carrierHasBluechat]="carrierHasBluechat"
                               [selected]="_selectedDeliveries[delivery.deliveryNumber]"
                               (select)="selectDelivery(delivery.deliveryNumber, $event)"
                               (createNoteClicked)="transformToLoadAndEmit(delivery)">
        </app-bluechat-delivery>
    </div>
</app-collapsible>
